import { APP_TOKEN_NAME, ROLE_ADMIN, ROLE_USER } from '@/config/constants';
import { generateStorageKey } from '@/utils';

const checkRouterWithToken = (token, to, userInfo) => {
    if (!token) {
        const publicPaths = ['/login', '/forgot-password', '/reset-password', '/setting-password'];
        if (publicPaths.includes(to.path)) {
            return true;
        }
        return { path: '/login' };
    }
    if (token) {
        if (!userInfo) {
            window.$cookies.remove(generateStorageKey(APP_TOKEN_NAME));
            return to.path === '/login' ? true : { path: '/login' };
        }

        if (userInfo) {
            let roleUser = parseInt(userInfo.type);
            const publicPaths = ['/login', '/forgot-password', '/reset-password'];
            if (publicPaths.includes(to.path)) {
                if (roleUser === ROLE_USER) {
                    return { path: '/share-user-children' };
                }
                if (roleUser === ROLE_ADMIN) {
                    return { path: '/data-link-multi' };
                }
            }
        }
    }
};

const checkPermissionRoleScreen = (type) => {
    let userInfo = JSON.parse(localStorage.getItem('KB_DEV_CUSTOMER'));
    let roleUser = parseInt(userInfo.type);
    switch (type) {
        case 'type_admin':
            return roleUser === ROLE_ADMIN ? true : { path: '/notFound' };
        case 'type_user':
            return roleUser === ROLE_USER ? true : { path: '/notFound' };
        case 'type_all':
            return true;
        default:
            return true;
    }
};

export { checkRouterWithToken, checkPermissionRoleScreen };
